import React, { useEffect, useState, useMemo } from 'react';
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { ChipList, Chip } from "@progress/kendo-react-buttons";
import { DialogFormHLPure, InputHLPure, TextAreaHLPure, InputFileHLPure, DialogPdfHLPure, DialogPdf, GridSelectionHLPure, CheckBoxHLPure, DialogYesNoHLPure, ButtonHLPure, SearchBarHLPure, ButtonActionsHL } from '../../pures';
import { AlertsDoc, AlertsVault, DeleteDoc, DowloadDoc, EditDoc, PrintDoc, SendDoc, ShareDoc, VersionDoc, EditVault, PrintVault, DownloadVault, DeleteVault, ShareVault, SendVault, VersionVault } from '../../../assets/logos/icons';
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { b64toBlob } from '../../../validators';

const DocumentPanelActions = (props) => {

    let {
        documentData,
        handleAlerts,
        handleEditDoc,
        handlePrintDoc,
        handleSendEmailDoc,
        handleShareDoc,
        handleDeleteDoc,
        handleVersionDoc,
        handleSingRequest,
        permissions,
        signedInGovo,
        url,
        toggleLoadingRequesting,
        handleFile,
        selectedFileName,
        selectedFile,
        handleDeleteFile,
        errorFile,
        selectedFileBase64,
        handleDownloadDoc,
        handleShowAlerts,
        fileExpSelected,
        userCollaborators,
        toggleErrorRequesting
    } = props

    const { t } = useTranslation()
    let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let permissionsCheckBox = [
        {
            name: t("documentPanelActions.alerts"),
            value: false,
            nameBD: 'alerts',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_ALERTS}`,
            checked: false
        },
        {
            name: t("documentPanelActions.edit"),
            value: false,
            nameBD: 'editMetadata',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_EDIT}`,
            checked: false
        },
        {
            name: t("documentPanelActions.print"),
            value: false,
            nameBD: 'print',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_PRINT}`,
            checked: false
        },
        {
            name: t("documentPanelActions.download"),
            value: false,
            nameBD: 'download',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`,
            checked: false
        },
        {
            name: t("documentPanelActions.delete"),
            value: false,
            nameBD: 'delete',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_TRASH}`,
            checked: false
        },
        {
            name: t("documentPanelActions.share"),
            value: false,
            nameBD: 'share',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SHARE}`,
            checked: false
        },
        {
            name: t("documentPanelActions.send"),
            value: false,
            nameBD: 'sendMail',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SEND}`,
            checked: false
        }, {
            name: t("documentPanelActions.version"),
            value: false,
            nameBD: 'version',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_VERSION}`,
            checked: false
        },
        {
            name: "Solicitud de firma",
            value: false,
            nameBD: 'signRequest',
            icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`,
            checked: false
        },

    ]

    const cellColumnOne = (props) => {
        return (
            <td className="documentPanelActions-cell-one">
                <div className="documentPanelActions-div-cell-one">
                    <CheckBoxHLPure
                        valueCheckBox={props.dataItem}
                        checkedState={props.dataItem.checked}
                        onChangeHandler={(event) => onChangeCheckShare(event, props.dataItem)}
                    />
                    <div className="documentPanelActions-div-user">
                        <span className="gridHLPure-userName">
                            {props.dataItem.name}
                        </span>
                        <span className="gridHLPure-fieldSubtitle">
                            {props.dataItem.email}
                        </span>
                    </div>
                </div>
            </td>
        );
    };


    const [urlDocs, setUrlDocs] = useState("");
    const [showDialogSendEmail, setShowDialogSendEmail] = useState(false)
    const [email, setEmail] = useState('')
    const [messageEmail, setMessageEmail] = useState('')
    const [errorInput, setErrorInput] = useState(false)
    const [errorInputText, setErrorInputText] = useState('')
    const [errorInputArea, setErrorInputArea] = useState(false)
    const [errorTextArea, setErrorTextArea] = useState('')
    const [showDialogVersion, setShowDialogVersion] = useState(false)
    const [blobUrl, setBlobUrl] = useState("");
    const [showDialogShare, setShowDialogShare] = useState(false)
    const [usersSend, setUsersSend] = useState('')
    const [messageShare, setMessageShare] = useState('')
    const [errorInputShare, setErrorInputShare] = useState(false)
    const [errorInputTextShare, setErrorInputTextShare] = useState('')
    const [usersSendGrid, setUsersSendGrid] = useState([])
    const [userSendGridSelected, setUserSendGridSelected] = useState({})
    const [usersChip, setUsersChip] = useState([])
    const [showDeleteDocument, setShowDeleteDocument] = useState(false)
    const [showDialogPrint, setShowDialogPrint] = useState(false)
    const [userSearch, setUserSearch] = useState('')
    const [usersGrid, setUsersGrid] = useState([])
    const [permisos, setPermisos] = useState(permissionsCheckBox)



    const mobileResolution = useMediaQuery("(max-width:560px)");
    const is2000 = useMediaQuery("(max-width:2000px)");
    const is1500 = useMediaQuery("(max-width:1500px)");
    const is1366 = useMediaQuery("(max-width:1366px)");
    let heightContainer = mobileResolution ? 450 : 800
    let widthContainer = mobileResolution ? 550 : 1000
    let heightBody = mobileResolution ? 230 : 400

    if (is2000) {
        heightBody = 550
    }

    if (is1500) {
        heightBody = 500
    }

    if (is1366) {
        heightContainer = 700
        heightBody = 420
    }

    const pdf = useMemo(() => <PdfReader className="pdfReader" file={selectedFileBase64} isFile src={`data:application/pdf;base64,${selectedFileBase64}`}  ></PdfReader>, [selectedFileBase64])

    let heightGrid = '230px'

    useEffect(() => {
        if (selectedFileBase64) {
            const blob = b64toBlob(selectedFileBase64, "application/pdf");
            setBlobUrl(blob);
        }
    }, [selectedFileBase64]);

    useEffect(() => {
        if (!url) return
        setUrlDocs(url)
    }, [url])

    useEffect(() => {
        if (!userCollaborators || userCollaborators.length === 0) return
        setUsersGrid(userCollaborators)
    }, [userCollaborators])

    useEffect(() => {
        if (!userSearch) return
        let usersFilter = userCollaborators.filter((item) => item.name.toLowerCase().includes(userSearch.toLowerCase()) || item.email.toLowerCase().includes(userSearch.toLowerCase()));
        setUsersGrid(usersFilter)
    }, [userSearch])

    const handleShowDialog = () => {
        setShowDialogSendEmail(true)
    }

    const handleCloseDialog = () => {
        setShowDialogSendEmail(false)
    }

    const handleChangeEmail = (e) => {
        setErrorInputText('')
        setErrorInput(false)
        let value = e.target.value
        value = (value) ? value : ''

        setEmail(value)
    }

    const handleChangeMessageEmail = (e) => {
        setErrorTextArea('')
        setErrorInputArea(false)
        let value = e.target.value
        value = (value) ? value : ''

        setMessageEmail(value)
    }

    const handleSubmitDialog = () => {
        if (!email || email === '' || !messageEmail || messageEmail === '') {
            let messageError = (!email || email === '') ? 'Es olbigatorio agregar un correo' : 'Es obligatorio agregar un mensaje'
            if (!email || email === '') {
                messageError = 'Es olbigatorio agregar un correo'
                setErrorInputText(messageError)
                setErrorInput(true)
            }

            if (!messageEmail || messageEmail === '') {
                messageError = 'Es obligatorio agregar un mensaje'
                setErrorTextArea(messageError)
                setErrorInputArea(true)
            }
            return
        }

        setShowDialogSendEmail(false)
        toggleLoadingRequesting(true)
        let emails = email
        let documentId = documentData.id
        let comments = messageEmail
        let fileIdExp = null
        if (documentData.infoType === 'Expediente') {
            fileIdExp = fileExpSelected.id
        }

        handleSendEmailDoc(emails, documentId, comments, setEmail, setMessageEmail, fileIdExp)
    }

    const handleShowDialogVersion = () => {
        setShowDialogVersion(true)
    }

    const handleCloseDialogVersion = () => {
        setShowDialogVersion(false)
        handleDeleteFile()
    }

    const handleOpenCloseDialogShare = () => {
        setErrorInputTextShare('')
        setErrorInputShare(false)
        setShowDialogShare(!showDialogShare)
    }

    const handleSubmitDialogShare = (e) => {
        if (!usersSendGrid || usersSendGrid.length === 0) {
            let messageError = 'Es obligatorio seleccionar un usuario'
            toggleLoadingRequesting(false)
            toggleErrorRequesting(messageError, 4000, false)
            return
        }

        let users = [...usersSendGrid]
        users = users.map((user) => {
            user.permissions = [...permisos]
            return user
        })
        let documentId = documentData.id
        handleShareDoc(users, documentId, setUsersSend, setUsersSendGrid, setUsersChip, setShowDialogShare, setMessageShare)

    }

    const handleShowDialogDelete = () => {
        setShowDeleteDocument(true)
    }

    const handleCloseDialogDelete = () => {
        setShowDeleteDocument(false)
    }

    const handleDeleteDocumento = () => {
        setShowDeleteDocument(false)
        handleDeleteDoc()
    }

    const handleShowDialogPrint = (e) => {
        // setShowDialogPrint(true)
        handlePrintDoc(e, documentData)
    }

    const handleCloseDialogPrint = () => {
        setShowDialogPrint(false)
    }

    const filterChangeUsers = (e) => {
        setUserSearch(e.target.value)
    }

    const onChangeCheckShare = (e, userSelected) => {
        let checked = e.target.checked
        let copyUsers = [...userCollaborators]
        let copyUsersSend = [...usersSendGrid]

        let usersChecked = copyUsers.map((user) => {
            if (user.email === userSelected.email) {
                user.checked = checked
            }
            return user
        })

        let newUsersSend = []
        if (checked) {
            copyUsersSend.push(userSelected)
            newUsersSend = [...copyUsersSend]
        } else {
            newUsersSend = copyUsersSend.filter(user => user.email !== userSelected.email)
        }

        setUsersSendGrid(newUsersSend)
        setUsersGrid(usersChecked)
    }

    const onClickBtnActions = (e, action) => {
        let newPermisos = permisos.map((permiso) => {
            if (permiso.name === action.name) {
                permiso.value = !permiso.value
                permiso.checked = !permiso.checked
            }

            return permiso
        })

        setPermisos(newPermisos)
    }

    const handleChangeMessageShare = (e) => {
        let value = e.target.value
        setMessageShare(value)
    }

    return (
        <div className='documentPanelActions-container' style={{ overflowX: 'auto', overflowY: 'hidden' }}>
            {
                permissions.alerts && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src="https://a3cloud-qa.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/boveda-digital/Alerts.svg" onClick={(e) => handleShowAlerts(e, documentData.id)} height="40" width="40" />
                        <h1>{t("documentPanelActions.alerts")}</h1>
                    </div>
                )
            }
            {
                permissions.edit && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_EDIT}`} onClick={(e) => handleEditDoc(e)} height="40" width="40" />
                        <h1>{t("documentPanelActions.edit")}</h1>
                    </div>
                )
            }
            {
                permissions.print && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_PRINT}`} onClick={(e) => handleShowDialogPrint(e)} height="40" width="40" />
                        <h1>{t("documentPanelActions.print")}</h1>
                    </div>
                )
            }
            {
                permissions.download && (
                    <div className='documentPanelActions-container-btns' onClick={() => handleDownloadDoc()}>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`}
                            height="40" width="40" />
                        <h1>{t("documentPanelActions.download")}</h1>
                    </div>
                )
            }
            {
                permissions.send && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SEND}`} onClick={(e) => handleShowDialog(e)} height="40" width="40" />
                        <h1>{t("documentPanelActions.send")}</h1>
                    </div>
                )
            }
            {
                permissions.share && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SHARE}`} onClick={(e) => handleOpenCloseDialogShare(e)} height="40" width="40" />
                        <h1>{t("documentPanelActions.share")}</h1>
                    </div>
                )
            }
            {
                permissions.delete && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SEND}`} onClick={(e) => handleShowDialogDelete(e)} height="40" width="40" />
                        <h1>{t("documentPanelActions.delete")}</h1>
                    </div>
                )
            }
            {
                permissions.version && (
                    <div className='documentPanelActions-container-btns'>
                        <input type="image" src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_VERSION}`} onClick={(e) => handleShowDialogVersion(e)} height="40" width="40" />
                        <h1>{t("documentPanelActions.version")}</h1>
                    </div>
                )
            }

            {
                (documentData.infoType === 'Documento' && !signedInGovo) && (
                    <div className='documentPanelActions-container-btns'>
                        <input
                            type="image"
                            src={`${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`}
                            onClick={(e) => handleSingRequest(e)}
                            height="40"
                            width="40"
                        />
                        <h1>{t("documentPanelActions.signRequest")}</h1>
                    </div>
                )
            }




            {
                showDialogSendEmail && (
                    <DialogFormHLPure
                        cancel={() => handleCloseDialog()}
                        titleDialog={`${t("documentPanelActions.title.dialog")} ${documentData.name}`}
                        descriptionActive={false}
                        descriptionDialog={t("documentPanelActions.dialog.description")}
                        textBtnCancel={t("button.cancel")}
                        saveBtn={t("button.send")}
                        handleSubmit={(e) => handleSubmitDialog(e)}
                    >
                        <div className='documentPanelActions-dialog-container'>
                            <InputHLPure
                                typeInput="text"
                                required
                                labelInput={t("documentPanelActions.dialog.emails")}
                                valueInput={email}
                                handleChangeInput={(e) => handleChangeEmail(e)}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                errorInput={errorInput}
                                errorInputText={errorInputText}
                            />
                            <div className='documentPanelActions-dialog-message'>
                                <TextAreaHLPure
                                    required
                                    labelTextArea={t("documentPanelActions.dialog.message")}
                                    valueTextData={messageEmail}
                                    handleChangeTextArea={(e) => handleChangeMessageEmail(e)}
                                    errorInput={errorInputArea}
                                    errorTextArea={errorTextArea}
                                />
                            </div>
                        </div>
                    </DialogFormHLPure>
                )
            }
            {
                showDialogVersion && (
                    <DialogPdfHLPure
                        title={t("documentPanelActions.dialog.version")}
                        description={documentData.name}
                        saveBtn={t("upload.btn")}
                        canelBtn={t("button.cancel")}
                        width={widthContainer}
                        height={heightContainer}
                        heightBody={heightBody}
                        handleFile={handleFile}
                        handleDeleteFile={handleDeleteFile}
                        cancel={() => handleCloseDialogVersion()}
                        handleSubmitProfile={(e) => handleVersionDoc(e, setShowDialogVersion, documentData.id, fileExpSelected.id)}
                    >
                        <Grid container lg={12} md={12} sm={12} es={12}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                es={12}
                                className="documentPanelActions-dialog-version-btns"
                            >
                                <InputFileHLPure
                                    messageBtn={t("documentPanelActions.dialog.version.btn.upload")}
                                    flex={true}
                                    acceptFile={"application/pdf"}
                                    selectedFile={selectedFile}
                                    selectedFileName={selectedFileName}
                                    errorFile={errorFile}
                                    handleFile={e => handleFile(e)}
                                    handleDeleteFile={e => handleDeleteFile(e)}
                                />
                            </Grid>

                            {/*View document*/}
                            {
                                selectedFileBase64 && (
                                    <div className='documentPanelActions-container-pdf'>
                                        <div className='documentPanelActions-version-pdf'>
                                            {pdf}
                                        </div>
                                        <div className="documentPanelActions-version-pdf-mobile">
                                            <DialogPdf blobUrl={blobUrl} />
                                        </div>
                                    </div>
                                )
                            }
                        </Grid>
                    </DialogPdfHLPure>
                )
            }
            {
                showDialogShare && (
                    <DialogFormHLPure
                        titleDialog={`${t("documentPanelActions.dialog.share")} ${documentData.name}`}
                        saveBtn={t("documentPanelActions.share")}
                        textBtnCancel={t("button.cancel")}
                        cancel={() => handleOpenCloseDialogShare()}
                        handleSubmit={(e) => handleSubmitDialogShare(e)}
                    >
                        <div className='documentPanelActions-dialog-share-container'>
                            <div className='documentPanelActions-search'>
                                <SearchBarHLPure
                                    placeholder={t("digitalVault.editDocument.placeholder.search")}
                                    onSearchChange={(e) => filterChangeUsers(e)}
                                    searchValue={userSearch}
                                />
                            </div>
                            <div className='documentPanelActions-grid-users'>
                                <Grid item className="documentPanelActions-grid-documents">
                                    <GridSelectionHLPure
                                        styleGeneral={true}
                                        styleGeneralClass={"documentPanelActions-general-grid"}
                                        pageable={false}
                                        skip={0}
                                        take={usersGrid.length}
                                        dataGrid={usersGrid}
                                        filter={true}
                                        onSelectedItem={userSendGridSelected}
                                        columnTwo={false}
                                        columnThree={false}
                                        columnFive={false}
                                        cellColumnOne={cellColumnOne}
                                        styleGrid={{ height: heightGrid }}
                                    />
                                </Grid>
                            </div>
                            <div className='documentPanelActions-div-actions-btns'>
                                <h1>{t("documentPanelActions.permissions.share")}</h1>
                                <div className='documentPanelActions-actions-btns'>
                                    {
                                        permisos.map((permiso) => {
                                            return (
                                                <ButtonActionsHL
                                                    nameBtn={permiso.name}
                                                    showIcon={true}
                                                    icon={permiso.icon}
                                                    onClickBtn={(e) => onClickBtnActions(e, permiso)}
                                                    selected={permiso.checked}
                                                />
                                            )
                                        })
                                    }
                                </div>
                                <div className='documentPanelActions-dialog-message'>
                                    <TextAreaHLPure
                                        labelTextArea={t("documentPanelActions.message.share")}
                                        valueTextData={messageShare}
                                        handleChangeTextArea={(e) => handleChangeMessageShare(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </DialogFormHLPure>
                )
            }
            {
                showDeleteDocument && (
                    <DialogYesNoHLPure
                        cancel={() => handleCloseDialogDelete()}
                        textBtnCancel={t("button.cancel")}
                        saveBtn={t("button.delete")}
                        titleDialog={t("documentPanelActions.title.dialog.delete")}
                        handleSubmit={() => handleDeleteDocumento()}
                    >
                        <div className='documentPanelActions-dialog-delete'>
                            <h1>{t("documentPanelActions.question.dialog.delete")}</h1>
                        </div>
                    </DialogYesNoHLPure>
                )
            }
            {
                showDialogPrint && (
                    <DialogFormHLPure
                        titleDialog={`Documento a imprimir: ${documentData.name}`}
                        cancel={() => handleCloseDialogPrint()}
                    >
                        <div className='documentPanelActions-print-dialog'>
                            <div className='documentPanelActions-print-dialog-embed'>
                                <embed id='fileDoc' type='application/pdf' width="450" height="400" />
                            </div>
                            <div className='documentPanelActions-print-dialog-btn-cancel'>
                                <ButtonHLPure
                                    nameBtn={'Cerrar'}
                                    onClickBtn={() => handleCloseDialogPrint()}
                                />
                            </div>
                        </div>
                    </DialogFormHLPure>
                )
            }
        </div>
    )
}

export default DocumentPanelActions